<div class="cols" [formGroup]="group()">
    <div class="col-2">
        <app-international-phone-input [formControl]="phoneInfoControl"> </app-international-phone-input>
    </div>

    <div class="col-3">
        <mat-form-field class="w-100" appearance="outline">
            <input matInput type="text" trim="blur" formControlName="ext" maxlength="{{ maxLengthDictionary.ext }}" />
            @if (extControl.invalid) {
                <mat-error>
                    <app-invalid-label [label]="'ext' | translate"></app-invalid-label>
                </mat-error>
            }
        </mat-form-field>
    </div>

    @if (showPrimaryInfo()) {
        <div class="col-4">
            <ng-content select="[radio]"></ng-content>
        </div>
    }

    <div class="col-5">
        <mat-form-field appearance="outline" class="select w-100">
            <mat-select [panelClass]="'custom-option-list'" disableOptionCentering formControlName="type">
                @for (type of types; track type) {
                    <mat-option [value]="type">{{ type | phoneTypeName | translate }}</mat-option>
                }
            </mat-select>
        </mat-form-field>
    </div>
</div>
